module.exports = {
      id: "dfc49fc4be4bafc0ce5f214044c39618bathroomEquipment-shower.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#dfc49fc4be4bafc0ce5f214044c39618bathroomEquipment-shower.svg",
      toString: function () {
        return this.url;
      }
    }